import { ScaleBarcodeFormat } from '../types'

/** EAN-13 / EAN-8 check digit of the digits before it. */
export const eanCheckDigit = (digits: string) => {
  const sum = Array.from(digits)
    .reverse()
    .reduce((acc, d, i) => acc + Number(d) * (i % 2 ? 1 : 3), 0)
  return (10 - (sum % 10)) % 10
}

export const isValidEan13 = (code: string) => /^\d{13}$/.test(code) && eanCheckDigit(code.slice(0, 12)) === Number(code[12])

/** POS.md §18.8: `21` + PLU (5) + grams (5) + check digit. The default when a business's scales name none. */
export const DEFAULT_SCALE_FORMAT: ScaleBarcodeFormat = {
  prefix: '21',
  plu_digits: 5,
  value: 'weight',
  value_digits: 5,
  value_decimals: 3,
  check_digit: true,
}

export type ScaleReading = { plu: string; weight?: number; price?: number }

/** Reads a scale label with the first format that fits, or null. Formats come from the business's scale models. */
export const parseScaleBarcode = (code: string, formats: ScaleBarcodeFormat[] = [DEFAULT_SCALE_FORMAT]): ScaleReading | null => {
  if (!/^\d+$/.test(code)) return null
  for (const f of formats) {
    const length = f.prefix.length + f.plu_digits + f.value_digits + (f.check_digit ? 1 : 0)
    if (code.length !== length || !code.startsWith(f.prefix)) continue
    if (f.check_digit && eanCheckDigit(code.slice(0, -1)) !== Number(code.at(-1))) continue
    const plu = code.slice(f.prefix.length, f.prefix.length + f.plu_digits)
    const raw = Number(code.slice(f.prefix.length + f.plu_digits, f.prefix.length + f.plu_digits + f.value_digits))
    const value = raw / 10 ** f.value_decimals
    if (!(value > 0)) continue
    return f.value === 'weight' ? { plu, weight: value } : { plu, price: value }
  }
  return null
}
